import React from 'react';
import PropTypes from 'prop-types';

import LoadingScreen from '../../../../components/LoadingScreen';
import PoweredByTurboTenant from '../../../../icons/PoweredByTurboTenant';

import EmbedPropertyListEmpty from './EmbedPropertyListEmpty';
import EmbedPropertyListItem from './EmbedPropertyListItem';

import styles from './EmbedPropertyList.module.scss';

const EmbedPropertyList = ({ properties, loading }) => {
  if (loading) {
    return <LoadingScreen loading={loading} className={styles.container} />;
  }

  return (
    <div className={styles.container}>
      {properties?.length > 0 ? (
        properties.map((property, index) => (
          <EmbedPropertyListItem key={index} property={property} />
        ))
      ) : (
        <EmbedPropertyListEmpty className={styles.emptyState} />
      )}
      <a
        className={styles.ttLink}
        href="http://turbotenant.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <PoweredByTurboTenant height={48} width={162} color={'yellow'} />
      </a>
    </div>
  );
};

EmbedPropertyList.propTypes = {
  properties: PropTypes.array,
  loading: PropTypes.bool,
};

export default EmbedPropertyList;
